export const projects = [
  {
    id: 1,
    name: "School Management System",
    context: "Full-stack platform built during a fullstack developer traineeship at Innoblooms.",
    details:
      "A comprehensive School Management System with responsive, user-friendly interfaces across Admin, Super Admin, Teacher, and Student panels. Integrated REST APIs for dynamic data rendering and seamless communication with backend services.",
    contribution:
      "Built key modules including student and teacher management, examination and exam-type management, result generation, recheck requests, dashboards, and performance analytics, plus reusable UI components to improve usability and maintainability.",
    tech: ["Next.js", "TypeScript", "Material UI", "REST APIs"],
    status: "Production · Internal deployment",
  },
  {
    id: 2,
    name: "Employee Management System",
    context: "Production system built from scratch, currently used within the organization.",
    details:
      "A production-ready Employee Management System covering the complete employee lifecycle — employee creation and management, department creation and administration, role-based access control, and authentication and authorization.",
    contribution:
      "Designed and developed RESTful APIs, built the React.js frontend, implemented the Node.js/Express.js backend, and managed PostgreSQL database operations to deliver a scalable, secure, production-ready application.",
    tech: ["React.js", "Node.js", "Express.js", "PostgreSQL"],
    status: "Production · Currently in use",
  },
];
